import React, { useEffect, useState, useContext, Suspense } from 'react';
import { bool, number } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { clickEvent, loadEvent } from '../publisher';
import { getIntroOfferLink } from '../utils';
import { smallCardIcon, smallCardCrc, cardInfoIcon } from '../constants';
import './intro-offer.style.scss';

// eslint-disable-next-line max-len
const IntroOfferApplyModal = React.lazy(() => import(/* webpackChunkName: "consumer-card-apply-now-model" */ '../intro-offer-apply-modal/intro-offer-apply-modal.component')
  .then((module) => ({ default: module.IntroOfferApplyModal })));

export const IntroOffer = ({
  mobile, paymentEstimatorLoaded, price, isB2B,
}) => {
  const [applyNowUrl, setApplyNowUrl] = useState(null);
  const { isConsumerApp } = useContext(ExperienceContext);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (paymentEstimatorLoaded) {
      loadEvent('plcc');
      setApplyNowUrl(getIntroOfferLink(mobile, 'pip', isB2B));
    }
  }, [paymentEstimatorLoaded]);

  const calculateIntroOfferDiscountPrice = (amount) => {
    return (amount - 25).toFixed(2);
  };

  const applyText = isB2B
    ? 'Apply for a Pro Xtra Credit Card'
    : 'Apply for a Home Depot Consumer Card';
  const cardIcon = isB2B ? smallCardCrc : smallCardIcon;

  return (
    <>
      {showModal
      && (
        <Suspense fallback={(<div />)}>
          <IntroOfferApplyModal
            applyNowUrl={applyNowUrl}
            closeModal={closeModal}
            isMobile={mobile}
            isB2B={isB2B}
            analyticsFeature="plcc-est-bundle"
          />
        </Suspense>
      )}
      <div className="buybox-credit-promo-message">
        <Image
          src={cardIcon}
          alt="Apply Now"
          title="Apply Now"
          height={50}
          width={50}
          className="credit-card-image"
        />
        <div>
          <div>
            Pay<strong> ${calculateIntroOfferDiscountPrice(price)}</strong>
          &nbsp;after <strong>$25 OFF</strong> your total qualifying purchase upon opening a new card.&nbsp;
            <Image
              src={cardInfoIcon}
              alt="info"
              title="Enjoy special savings with your new account"
              height={12}
              width={12}
              onClick={openModal}
              className="credit-card-info"
            />
          </div>
          <a
            href={applyNowUrl}
            className="u__default-link"
            target={isConsumerApp ? '_self' : '_blank'}
            rel="noopener noreferrer"
            onClick={() => clickEvent('plcc')}
          >
            {applyText}
          </a>
        </div>
      </div>
    </>
  );

};

IntroOffer.displayName = 'IntroOffer';

IntroOffer.propTypes = {
  mobile: bool.isRequired,
  paymentEstimatorLoaded: bool.isRequired,
  price: number.isRequired,
  isB2B: bool.isRequired,
};
